import usePrevious from "./usePrevious";

/**
 * Mimics componentDidUpdate in class based components
 */
export const useHasChanged = (val): boolean => {
    const prevVal = usePrevious(val)

    return prevVal !== val
}